import React from 'react';
import styled from 'styled-components';
import {
  spacer20,
  spacer32,
  spacer40,
  gray50,
  white,
} from '@spotify-internal/encore-foundation';
import {
  IconLink,
  IconFacebook,
  IconTwitter,
} from '@spotify-internal/encore-web';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { Link } from './Link';
import { withoutProps } from '../utils';

const InlineShareButtons = styled.div`
  padding-bottom: ${spacer40};
  a:focus:not(:disabled) {
    outline: 1px auto -webkit-focus-ring-color;
  }
`;

const SocialButton = styled(withoutProps(Link, 'textColor'))<{
  textColor?: string;
}>`
  padding-right: ${spacer20};

  :last-of-type {
    padding-right: 0;
  }

  svg {
    color: ${({ textColor }) => (textColor ? textColor : white)};
    height: ${spacer32};

    &:hover {
      color: ${({ textColor }) =>
        textColor ? hexToRgba(textColor, 0.75) : hexToRgba(white, 0.75)};
    }
  }
`;

const loadScript = (hasWindow: boolean) => {
  return new Promise((resolve, reject) => {
    if (!hasWindow || !process.env.REACT_APP_ADDTHIS_ID) {
      resolve();
      return;
    }

    // @ts-ignore
    if (window.addthis) {
      // @ts-ignore
      resolve(window.addthis);
      return;
    }

    const firstScript: HTMLScriptElement = document.getElementsByTagName(
      'script',
    )[0];
    const newScript: HTMLScriptElement = document.createElement('script');

    newScript.onerror = reject;
    newScript.onload = () => {
      // @ts-ignore
      resolve(window.addthis);
    };

    newScript.async = true;
    newScript.src = `//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5f2451e75305abf2`;
    if (firstScript) {
      // @ts-ignore
      firstScript.parentNode.insertBefore(newScript, firstScript);
    }
  });
};

// add share links to video module and article module
function loadAddThis() {
  const hasWindow: boolean = typeof window === 'object';
  let singleton;
  if (!singleton) {
    singleton = loadScript(hasWindow);
  }

  return singleton;
}

type ShareButtonsType = {
  textColor?: string;
};

export const ShareButtonsComponent: React.FC<ShareButtonsType> = ({
  textColor = '',
}) => {
  React.useEffect(() => {
    loadAddThis();
  }, []);
  const TRACK_CAT = 'frodor_share';
  function copyToClipboard() {
    navigator.clipboard.writeText(window.location.href);
  }
  return (
    <InlineShareButtons className="addthis_toolbox">
      <SocialButton
        external
        className="addthis_button_facebook"
        track={[TRACK_CAT, 'facebook']}
        textColor={textColor}
        href="/"
      >
        <IconFacebook aria-label="FacebookIcon" />
      </SocialButton>
      <SocialButton
        external
        className="addthis_button_twitter"
        track={[TRACK_CAT, 'twitter']}
        textColor={textColor}
        href="/"
      >
        <IconTwitter aria-label="TwitterIcon" />
      </SocialButton>
      <SocialButton
        external
        track={[TRACK_CAT, 'link_copy']}
        textColor={textColor}
        href="/"
      >
        <IconLink onClick={copyToClipboard} aria-label="LinkIcon" />
      </SocialButton>
    </InlineShareButtons>
  );
};
